import {DataService} from '../data.service';
import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, catchError} from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class UserPreferencesService extends DataService {
  private baseURI = this.apiUri + '/userprofile/';

  constructor(http: HttpClient) {
    super(http);
  }

  getUserPrefs(userId: string, organizationId: string, screenName: string): Observable<any> {
    this.setUri(this.baseURI + 'preferences/' + userId + '/userId/' +
      organizationId + '/organizationId/' +
      screenName + '/screenName');
    return this.get().pipe(catchError(this.handleError));
  }

  saveUserPrefs(userPref: any): Observable<string> {
    return this.http.post<string>(this.baseURI + 'preferences/save', userPref);
  }

  getAllFederalHolidays(): Observable<any> {
    return this.http.get<any>(this.apiUri + '/federalHolidays/getAllHolidays/');
  }

}
